<template>
  <div class="modal-app">
    <div class="overlay"></div>
    <div class="content">
      <div class="content-body">
        <div>
          <component :is="component" v-bind="attrs" @close="close">
            <slot />
          </component>
        </div>
        <div>
          <button @click="close()">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    component: {
      type: Object,
    },
    values: {
      type: Object,
    },
  },
  methods: {
    close() {
      console.log('ok');
      this.$emit('close');
    },
  },
  computed: {
    attrs() {
      return this.values;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-app {
  z-index: 999;
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  .overlay {
    background: #d8b5ff70;
    height: 100vh;
  }
  .content {
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content-body {
    padding: 1rem;
    background: white;
    border-radius: 10px;
    width: 70%;
    height: 70%;
    box-shadow: 0 0 3px #d1bbbb;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
